import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface UseImportHandlerProps {
    editor: any;
    enqueueSnackbar: (message: string, options?: any) => void;
}

export const useImportHandler = ({ editor, enqueueSnackbar }: UseImportHandlerProps) => {
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null);

    const handleImportClick = useCallback(() => {
        if (inputRef.current) inputRef.current.click();
    }, []);

    const handleImportFileOnChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || !event.target.files[0]) return;

        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = function (event) {
            const text = event.target?.result;
            try {
                const data = JSON.parse(text as string);
                if (typeof data === 'object' && data !== null) {
                    editor.fromJSON(data);
                }
            } catch (error) {
                enqueueSnackbar(t("lessonEditor.errorImportNodeEditorFile"), {
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    variant: 'error'
                });
            }
        };

        reader.readAsText(file);
    }, [editor, enqueueSnackbar, t]);

    return {
        inputRef,
        handleImportClick,
        handleImportFileOnChange
    };
};